<div class="grid-container margin-top">
    <h3>Reminders</h3>
    
    <button (click)="generateAllActiveReminders()" class="button" aria-label="Generate All Active Reminders" title="Generate All Active Reminders">
        Generate All Active Reminders (For Testing Only)
    </button>
    <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="reminders" aria-label="Reminder List"></ag-grid-angular>
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
